<div class="p-form-layout02 p-booking-info-mdl__row--mt16">
  <div class="p-form-layout02__item">
    <h3
      class="p-form-layout02__item-title p-form-layout02__item-title--l"
      [innerHTML]="'heading.receipt' | staticMsg"
    ></h3>
    <div [formGroup]="receiptFormGroup" class="p-form-layout02__item-body">
      <div class="p-form-layout02__item-body-box p-form-layout02__item-body-box--w325">
        <asw-input
          id="payment-credit-receipt-name"
          label="{{ 'label.receiptName' | staticMsg }}"
          formControlName="receiptName"
          (change$)="receiptChange()"
          required
          placeholder="{{ 'placeholder.receiptName' | staticMsg }}"
        ></asw-input>
      </div>
    </div>
  </div>
</div>
